export class MicroappFbsMyReservationsFilter{
    general:string;
}